export const PossibleMilitaryStatuses = [
  {
    name: 'None',
    key: 'None'
  },
  {
    name: 'Active',
    key: 'Active'
  },
  {
    name: 'Veteran',
    key: 'Veteran'
  }
];
